import { FileDownload } from '@mui/icons-material';
import { Button, Card, CardContent, Grid, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useNotification } from '../../../../hooks/NotificationContext';
import {
  createExportRequest,
  getUserProjectList,
} from '../../../../modules/project';
import { getExportRequests } from '../../../../modules/users';
import Modal from '../../../elements/Modal';
import ExportDataSelectionForm from './ExportDataSelectionForm';
import { ExportDataConfirmation } from './ExportDataConfirmation';
import ExportRequestsAlert from './ExportRequestsAlert';

export const ExportData = () => {
  const [openModal, setOpenModal] = useState(false);
  const [step, setStep] = useState('confirm');
  const { addNotification } = useNotification();
  const [exportRequests, setRequests] = useState(null);
  const [loading, setLoading] = useState(false);
  const [projects, setProjects] = useState([]);
  const initialOptions = {
    projects: [],
    options: [],
  };
  const [exportOptions, setExportOptions] = useState(initialOptions);
  const [disableExport, setDisableExport] = useState(false);

  const fetchExportRequests = async () => {
    try {
      const exportRequestsResponse = await getExportRequests();
      setRequests(exportRequestsResponse);
    } catch (error) {
      console.log(error, 'Unable to fetch current project');
    }
  };

  const handleOpenModal = () => {
    setStep('confirm');
    setOpenModal(true);
  };

  const handleClose = () => {
    setOpenModal(false);
    setStep('');
    setExportOptions(initialOptions);
  };

  const exportData = async (exportType, existingRequest) => {
    const payload = {
      projects: exportOptions.projects,
      options: ['testcases'],
      existingRequest: existingRequest || null,
      exportType: exportType,
    };
    try {
      await createExportRequest(payload);
      // addNotification('success', 'Request to export data raised successfully');
      setStep('confirmed');
      fetchExportRequests();
    } catch (error) {
      addNotification('error', 'Failed to create export request');
    }
  };

  const fetchProjects = async () => {
    setLoading(true);
    try {
      const projectData = await getUserProjectList();
      setProjects(projectData?.projects);
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchExportRequests();
    fetchProjects();
  }, []);

  return (
    <>
      <Card sx={{ p: 2 }}>
        <Grid container spacing={2}>
          <Grid
            item
            xs={12}
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}>
            <Typography variant="h5">Export Your Data</Typography>
            <Button
              variant="outlined"
              onClick={handleOpenModal}
              disabled={loading || projects?.length === 0}
              title={projects.length === 0 ? 'No projects found' : 'Export Data'}>
              <FileDownload sx={{ fontSize: 20, mr: 1 }} />
              Export
            </Button>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body2" color="textSecondary">
              Export your project data for backup or analysis.
            </Typography>
          </Grid>
          <ExportRequestsAlert
            exportRequests={exportRequests}
            projects={projects}
          />
        </Grid>
      </Card>

      <Modal
        open={openModal}
        width="sm"
        modalTitle="Export Data"
        handleClose={handleClose}
        action={() => (
          <>
            {step === 'confirm' && (
              <>
                <Button variant="outlined" onClick={handleClose}>
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  onClick={() => exportData('new')}
                  disabled={
                    exportOptions.projects.length === 0 || disableExport
                  }>
                  Export
                </Button>
              </>
            )}
            {step === 'confirmed' && (
              <Button variant="contained" onClick={handleClose}>
                Close
              </Button>
            )}
          </>
        )}>
        <CardContent sx={{ pt: 0, p: 0 }}>
          {step === 'confirm' && (
            <>
              <ExportDataConfirmation
                projects={projects}
                exportRequests={exportRequests}
                exportOptions={exportOptions}
                exportData={exportData}
                setDisableExport={setDisableExport}
              />
              <ExportDataSelectionForm
                projects={projects}
                exportOptions={exportOptions}
                setExportOptions={setExportOptions}
              />
            </>
          )}
          {step === 'confirmed' && (
            <>
              <Typography variant="h6">
                Request to export data has been successfully created.
              </Typography>
              <Typography variant="body2" sx={{ mt: 2 }}>
                This process may take some time. Once completed, we will send a
                confirmation to your registered email.
              </Typography>
            </>
          )}
        </CardContent>
      </Modal>
    </>
  );
};
